import { render, staticRenderFns } from "./SxAssetAddOrUpdate.vue?vue&type=template&id=e0f7827e&scoped=true&"
import script from "./SxAssetAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SxAssetAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f7827e",
  null
  
)

export default component.exports